import React from "react";

import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import DatasetUsageSearch from "./DatasetUsageSearch";

type DatasetUsageSearchDialogProps = {
  visible: boolean;
  closeDialog: () => void;
}

const DatasetUsageSearchDialog: React.FC<DatasetUsageSearchDialogProps> = ({ visible, closeDialog }) => {
  return (
    <Dialog
      visible={visible}
      onHide={closeDialog}
      header={T("action.search-dataset")}
      style={{ width: "min(100vw, 1000px)" }}
      resizable
      draggable
    >
      <DatasetUsageSearch />
    </Dialog>
  );
}

export default DatasetUsageSearchDialog;